import { requirePermissionGuard } from "@/shared/rbac";
import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";

/**
 * Search params: proklik „Všechny přihlášky" z karty klienta → přihlášky
 * konkrétního klienta. `klientNazev` je jen popisek pro filtr-chip.
 * Neplatné hodnoty tiše zahodíme (vzor /dashboard/klienti).
 */
const prihlaskySearchSchema = z.object({
  klientId: z.string().uuid().optional().catch(undefined),
  klientNazev: z.string().max(255).optional().catch(undefined),
});

export const Route = createFileRoute("/dashboard/prihlasky")({
  validateSearch: (search) => prihlaskySearchSchema.parse(search),
  beforeLoad: requirePermissionGuard("hca.prihlasky.read"),
});
